import { NgModule } from '@angular/core';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { Pages404Component } from './404/404.component'
import { Pages500Component } from './500/500.component'
import { PagesAboutComponent } from './about/about.component'
import { PagesContactComponent } from './contact/contact.component'
import { PagesHomeComponent } from './home/home.component'
import { PagesWorkComponent } from './work/work.component'

import { ComponentsModule } from '../components/components.module'
import { RouterModule }   from '@angular/router';
import { LayoutsModule } from '../layouts/layouts.module'
import { MaterialModule } from '../components/material.module'
import { ScrollToModule } from '@nicky-lenaers/ngx-scroll-to';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';


export const PAGES = [
  Pages404Component,
  Pages500Component,
  PagesAboutComponent,
  PagesContactComponent,
  PagesHomeComponent,
  PagesWorkComponent
];

@NgModule({
    imports : [
        RouterModule,
        ComponentsModule,
        ReactiveFormsModule,
        LayoutsModule,
        MaterialModule,
        ScrollToModule.forRoot(),
        BrowserAnimationsModule
    ],
    declarations: PAGES,
    exports: PAGES
})
export class PagesModule {}



// WEBPACK FOOTER //
// ./src/app/pages/pages.module.ts